import React from 'react';

/**
 * Premium card primitive.
 * 1px line border, no default shadow, hover lifts -3px + border color shift.
 */
export const FeatureCard = ({ className = '', children, ...rest }) => (
  <article
    className={
      'group relative bg-surface border border-line rounded-card p-7 md:p-8 ' +
      'transition-[transform,border-color,box-shadow] duration-200 ease-out-quart ' +
      'hover:-translate-y-[3px] hover:border-ink/30 ' +
      className
    }
    {...rest}
  >
    {children}
  </article>
);

export default FeatureCard;
